module.exports = __webpack_public_path__ + "static/media/winhlp32_4002.c56aa034.ico";